import React from 'react';
import { ThemeProvider } from '../styled-components';
import { theme } from './theme';

export const withTheme = (Component: JSX.Element): JSX.Element => (
  <ThemeProvider theme={theme}>{Component}</ThemeProvider>
);
